// extracted by mini-css-extract-plugin
export default {"smallTitle":"smallTitle_smallTitle__bf9lB"};